module.exports = __webpack_public_path__ + "img/pvc_600g_farbauswahl_komplett.75a652b8.jpg";